$ = require 'jquery'
ApiError = require 'app/scripts/network/api-error'
Auth = require 'app/scripts/db/auth'
Payloads = require 'app/scripts/network/payloads'
Promise = require 'bluebird'
_ = require 'underscore'
{ ErrorViews } = require 'app/common/data/error-views'
{ useNonPublicIfAvailable } = require 'app/common/lib/util/non-public-fields-filter'
{ InviteRestrictValues } = require 'app/scripts/views/organization/constants'

getCookieData = (expectedType) ->
  invitationData = $.cookie('invitation') || ''
  [type, id, secret] = invitationData.split(':')
  if type != expectedType
    id = null
  { id, secret }

module.exports =
  routes: [
    ['invite/accept-board', 'handleBoardCookieInvitation']
    ['invite/accept-team', 'handleTeamCookieInvitation']
  ]

  _handleInvitation: ({ id, loadModel, targetUrl, transferUrl, viewType, apiUrl, nameFromInvite, emailRestrictionsFromInvite, managedRestrictionsFromInvite, modelName }) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ApiPromise = require 'app/scripts/network/api-promise'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    InvitationLinkView = require 'app/scripts/views/invitation-link/invitation-link-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    RequestAdminInviteView = require 'app/scripts/views/invitation-link/request-admin-invite-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    JoinOnConfirm = require 'app/scripts/lib/join-on-confirm'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    redirectIfMember = =>
      ModelLoader.await('headerData')
      .then =>
        if !Auth.isLoggedIn()
          throw ApiError.Unauthorized()
        loadModel()
      .then =>
        if (url = targetUrl())?
          @navigate url, { trigger: true, replace: true }
        else
          throw ApiError.Unauthorized()

    # Immediately start fetching the invitation data
    getInvite =
      if apiUrl?
        ApiPromise
          url: apiUrl
          type: 'get'
      else
        Promise.reject(ApiError.NotFound())

    Promise.using @getSpinner(), =>
      $('#content').html('<div class="spinner loading"></div>')
      JoinOnConfirm.autoJoin()
      .then ->
        # Check to see if we're already a member of the board, in which case
        # we can go straight there.  Otherwise, go through the invitation
        # acceptance process
        redirectIfMember()
      .catch ApiError.NotFound, ApiError.Unauthorized, ApiError.Unconfirmed, =>
        @clearPreviousView()

        me = Auth.me()
        if me?
          @setViewType(me)

        @showHeader()

        Promise.props
          invite: getInvite
          member:
            if Auth.isLoggedIn()
              ModelLoader.for 'top-level', 'loadMemberLogins', Auth.myId()
        .then ({ invite }) =>
          invite.memberInviter.fullName = useNonPublicIfAvailable(invite.memberInviter, 'fullName')
          if !invite.inviteeCanAccept
            invitationLinkView = @topLevelView RequestAdminInviteView, me,
              memberInviter: invite.memberInviter

          else
            invitationLinkView = @topLevelView InvitationLinkView, me,
              inviter: invite.memberInviter
              name: nameFromInvite(invite)
              emailRestrictions: emailRestrictionsFromInvite(invite)
              allowManagedMembers: managedRestrictionsFromInvite(invite)
              inviteIdEnterprise: invite.organization?.idEnterprise
              transferUrl: transferUrl?()
              willJoinOnConfirm: JoinOnConfirm.inQueue(apiUrl)
              fxJoin: ->
                ApiPromise
                  method: 'post'
                  url: apiUrl
                .then(redirectIfMember)
              fxQueueJoin: ->
                JoinOnConfirm.add(apiUrl)
              modelName: modelName

          $('#content').html(invitationLinkView.render().el)



  handleBoardInvitation: (shortLink, secret) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    apiUrl = if shortLink && secret
      "/1/board/#{ shortLink }/invitationSecret/#{ secret }"
    else
      null

    @_handleInvitation
      loadModel: ->
        if shortLink
          ModelLoader.for 'top-level', 'loadBoardData', shortLink, Payloads.currentBoardMinimal
        else
          throw ApiError.BadRequest('invalid board shortLink')
      targetUrl: =>
        if (board = ModelCache.get('Board', shortLink))?
          if board.isMember(Auth.me())
            return @getBoardUrl(board)
        null
      viewType: 'board-invitation-link'
      apiUrl: apiUrl
      nameFromInvite: (invite) -> invite.board.name
      emailRestrictionsFromInvite: -> []
      managedRestrictionsFromInvite: -> []
      modelName: "Board"
    .catch ApiError, =>
      # The invitation link isn't valid anymore, show a message to that effect
      @displayErrorPage
        errorType: ErrorViews.BOARD_INVITATION_NOT_FOUND
    .done()
    return

  handleOrgInvitation: (orgName, secret) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    apiUrl = if orgName && secret
      "/1/organization/#{ orgName }/invitationSecret/#{ secret }"
    else
      null

    @_handleInvitation
      loadModel: ->
        if orgName
          ModelLoader.for 'top-level', 'loadOrganizationData', orgName
        else
          throw ApiError.BadRequest('invalid orgname')
      targetUrl: =>
        if (org = ModelCache.findOne 'Organization', (o) -> o.get('name') == orgName)?
          if org.isMember(Auth.me())
            return @getOrganizationUrl(orgName)
        null
      transferUrl: ->
        "/#{ orgName }/transfer-account"
      viewType: 'org-invitation-link'
      apiUrl: apiUrl
      nameFromInvite: (invite) -> invite.organization.displayName
      emailRestrictionsFromInvite: (invite) ->
        invite.organization.prefs?.orgInviteRestrict?.filter((value) -> !Object.values(InviteRestrictValues).includes(value)) ? []
      managedRestrictionsFromInvite: (invite) ->
        invite.organization.prefs?.orgInviteRestrict?.some((value) -> [
          InviteRestrictValues.MANAGED,
          InviteRestrictValues.MANAGED_OR_DOMAIN
        ].includes(value)) ? false
      modelName: "Team"
    .catch ApiError, (e) =>
      # The invitation link isn't valid anymore, show a message to that effect
      @displayErrorPage
        errorType: ErrorViews.ORG_INVITATION_NOT_FOUND
    .done()
    return

  handleBoardCookieInvitation: ->
    { id: shortLink, secret } = getCookieData('board')
    @handleBoardInvitation(shortLink, secret)

  handleTeamCookieInvitation: ->
    { id: orgName, secret } = getCookieData('organization')
    @handleOrgInvitation(orgName, secret)
